import { useCallback, useMemo } from "react";
import { createUseStyles } from "react-jss";
import { Row, Col, Typography } from "antd";
import { FormattedMessage } from "react-intl";
import { LeftOutlined, RightOutlined } from "@ant-design/icons";

import IconButton from "../../../../app/generic/iconButton";

const useStyles = createUseStyles({
  navRow: (props) => ({
    left: "50%",
    zIndex: 9999,
    position: "absolute",
    bottom: props.top ? "94%" : 0,
    transform: "translateX(-50%)",
  }),
});

const Navigation = ({ top, show, numPages, pageNumber, onPageChange }) => {
  const handlePreviousPageClick = useCallback(() => {
    onPageChange(-1);
  }, [onPageChange]);
  const handleNextPageClick = useCallback(() => {
    onPageChange(1);
  }, [onPageChange]);

  const classes = useStyles({
    top,
  });

  const pages = useMemo(
    () => (
      <Row justify="center">
        <Col>
          <Typography.Text strong>
            <FormattedMessage
              id="messages.pages"
              defaultMessage="Strana {from} z {to}"
              values={{
                from: pageNumber || (numPages ? 1 : "--"),
                to: numPages || "--",
              }}
            />
          </Typography.Text>
        </Col>
      </Row>
    ),
    [numPages, pageNumber]
  );

  return (
    <Row className={classes.navRow}>
      <Col>
        {(show || !top) && (
          <>
            {top && pages}
            <Row gutter={15}>
              <Col>
                <IconButton
                  icon={<LeftOutlined />}
                  disabled={pageNumber <= 1}
                  onClick={handlePreviousPageClick}
                />
              </Col>
              <Col>
                <IconButton
                  icon={<RightOutlined />}
                  onClick={handleNextPageClick}
                  disabled={pageNumber >= numPages}
                />
              </Col>
            </Row>
            {!top && pages}
          </>
        )}
      </Col>
    </Row>
  );
};

export default Navigation;
